/* eslint-disable no-prototype-builtins */
import React from "react";
import { Container, Wrapper } from "./styled";
import Checkbox from "../CheckBox";
import Description from "./components/Description";
import Article from "./components/Article";
import { secondLevel, thirdLevel } from "./components/Article/functions";

const ArticleCell = ({ row, addItem, value }) => {
  return (
    <Wrapper subRow={row.canExpand}>
      <Container subRow={secondLevel(row)} thirdLevel={thirdLevel(row)}>
        <Checkbox {...row.getToggleRowSelectedProps()} show={row.canExpand} row={row} addItem={addItem} />
        <Article row={row} value={value} />
      </Container>
      <Description row={row} />
    </Wrapper>
  );
};

export default ArticleCell;
